export default __webpack_public_path__ + "static/media/risks.c8734338.png";